import { IGame } from "./../../entities";
import { provider } from "../../providers";
import { GameType } from "../../../../src/screens/new-game/NewGame.types";

export interface CreateGamePayload {
  groupId: number;
  datetime: Date;
  location: string;
  notes: string;
  gameType: GameType;
  opponentTeam?: string;
  playAs?: string;
  groupName?: string;
  seasonId?: number | null;
  organizationId?: number | null;
}

export const CreateGame = async (params: CreateGamePayload): Promise<IGame> => {
  const gameType = params.gameType === GameType.TRAINING ? GameType.TRAINING : GameType.COMPETITIVE;
  const hostTeamName =
    gameType === GameType.TRAINING ? "Beli" : params.playAs === "host" ? params.groupName : params.opponentTeam;
  const visitorTeamName =
    gameType === GameType.TRAINING ? "Markeri" : params.playAs === "guest" ? params.groupName : params.opponentTeam;

  return provider.Request("/groups/{id}/game", {
    ...params,
    game_type: gameType,
    playing_as_host: params.playAs ? params.playAs === "host" : undefined,
    host_team_name: hostTeamName,
    visitor_team_name: visitorTeamName,
    season_id: params.seasonId,
    organization_id: params.organizationId,
  });
};
